module.exports = __webpack_public_path__ + "img/step1.3c1f6a75.jpg";